import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';

import FieldSettingsStore from '../services/fieldSettings/FieldSettingsStore';
import FieldSettingsContext from '../services/fieldSettings/FieldSettingsContext';

import { OnOffRadioButton } from '../components/radiobutton/OnOffRadioButton';
import { SelectHour } from '../components/select/SelectHour';
import { SelectMin } from '../components/select/SelectMin';
import { SelectBox } from '../components/select/SelectBox';
import { isNullOrUndefinedOrEmptyStr } from '../utilities/stringUtil';
import { messageUtility } from '../utilities/messageUtility';
import { isManagerRoleId, isPrimeRoleId } from '../utilities/roleUtility';
import LocalStorageService from '../services/utilities/LocalStorageService';
import { InOutFieldAreas } from './InOutFieldAreas';
import _urlParamManager from '../utilities/urlParamManager';
import EventManager, { EventType } from '../utilities/EventManager';
import {
  Information,
  Confirmation,
  ConfirmAppStart,
  ConfirmAppEnd,
} from '../components/modals/common/';

import {
  RECORDING_METHOD,
  DIALOG_STATUS,
  BODY_TEMPERATURE_THRESHOLD,
  SPOT_CHECK_STATUS,
  K_MOBILE_CHECK_STATUS,
  INTEGRATION_SERVICES,
  RADIO_BUTTON,
} from '../utilities/constants';

import styles from '../styles/componentStyle/fieldSettings/fieldSettings.scss';
import { LoadingModal } from '../components/modals/common/LoadingModal';
import { FormList } from '../components/CommonFormComponents';
import ReactDropDownCalender from '../components/ReactDropDownCalender';
import RequireIcon from '../components/RequireIcon';

/**
 * 現場設定画面
 */
export class FieldSettings extends React.Component {
  // 画面表示
  render() {
    return (
      <FieldSettingsStore>
        <FieldSettingsContext.Consumer>
          {({
            state,
            toggleAutomaticApproval,
            toggleRecordingMethod,
            toggleSpotFlg,
            toggleKMobileFlg,
            toggleIntegrationService,
            toggleUnidentifiedLogsAutoSend,
            updateOriginalFieldId,
            setTimeHours,
            setTimeMinutes,
            setBodyTemperatureThreshold,
            closeDialog,
            updateFieldSettings,
            registerFaceImages,
            shouldBeDisabled,
            checkFaceAppServiceStartEnd,
            toggleConfirmCheckbox,
            setVisibleDownloadErrorDialog,
            downloadFile,
            toggleUseWorkerEntranceAppFlg,
            toggleCheckInReflectToResult,
            setReflectToResultStartDate,
            offCheckInReflectToResult,
          }) => (
            <React.Fragment>
              <div id='main' className='main'>
                <Helmet title={data.title} />
                <div className='main__header'>
                  <h1>{data.title}</h1>
                </div>
                <div className={`${styles.form} main__body`}>
                  <div className='setting-header'>
                    <div className='field-settings-main__header'>
                      <div className='setting-header__item'>
                        <button
                          className={
                            state.errorStartDate
                              ? 'btn--effective btn--disabled'
                              : 'btn--effective'
                          }
                          disabled={state.errorStartDate}
                          type='submit'
                          onClick={() => checkFaceAppServiceStartEnd()}
                        >
                          {data.button.update}
                        </button>
                        {state.errorStartDate && (
                          <span className='alert-text'>
                            {messageUtility.getMessage('E-000-014')}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='field-settings-main__body'>
                    <FormList isSpace={true}>
                      <li className='form-list__item'>
                        <div className='day-crossing-time__label'>
                          <span className='label'>
                            {data.form.title.day_crossing_time}
                          </span>
                        </div>
                        <div className='day-crossing-time__element'>
                          <SelectHour
                            className='day_crossing_time_hours'
                            name='day_crossing_time_hours'
                            value={
                              state.settings.day_crossing_time
                                ? state.settings.day_crossing_time.hours()
                                : 0
                            }
                            onChange={event => setTimeHours(event.target.value)}
                          />
                          <span className='dialog__colon'>
                            {data.dateColon}
                          </span>
                          <SelectMin
                            className='day_crossing_time_minutes'
                            name='day_crossing_time_minutes'
                            value={
                              state.settings.day_crossing_time
                                ? state.settings.day_crossing_time.minutes()
                                : 0
                            }
                            onChange={event =>
                              setTimeMinutes(event.target.value)
                            }
                          />
                        </div>
                      </li>
                      <li className='form-list__item'>
                        <OnOffRadioButton
                          label={data.form.title.recording_method}
                          name='recording_method'
                          onButtonLabel={RECORDING_METHOD.entranceAndExit.name}
                          offButtonLabel={RECORDING_METHOD.onlyAdmission.name}
                          value={state.settings.recording_method}
                          onChange={() => toggleRecordingMethod()}
                        />
                        <div className='recording-method-comment-wrapper'>
                          <div className='recording-method-comment safari-linebreak'>
                            {data.form.recording_method_comment}
                          </div>
                          <div className='recording-method-banken-comment'>
                            <div className='reference-mark'>
                              {data.referenceMark}
                            </div>
                            <div className='safari-linebreak'>
                              {data.form.recording_method_banken_comment}
                            </div>
                          </div>
                        </div>
                      </li>
                      {/* https://e-reverse.backlog.jp/view/BLDE_V2-10576#comment-60103838 */}
                      {/* 上記チケットの経緯で画面表示は削除 (APIはそのままの為、取得したデータをそのまま返す) */}
                      {/*<li className='form-list__item'>*/}
                      {/*  <OnOffRadioButton*/}
                      {/*    label={data.form.title.ccus_auto_send}*/}
                      {/*    name='ccus_auto_send_flg'*/}
                      {/*    onButtonLabel={data.button.on}*/}
                      {/*    offButtonLabel={data.button.off}*/}
                      {/*    value={state.settings.ccus_auto_send_flg}*/}
                      {/*    onChange={() => toggle('ccus_auto_send_flg')}*/}
                      {/*  />*/}
                      {/*</li>*/}
                      <li className='form-list__item'>
                        <OnOffRadioButton
                          label={data.form.title.automatic_approval}
                          name='automatic_approval_flg'
                          onButtonLabel={data.button.on}
                          offButtonLabel={data.button.off}
                          value={state.settings.automatic_approval_flg}
                          onChange={() => toggleAutomaticApproval()}
                        />
                      </li>
                      <li className='form-list__item'>
                        <OnOffRadioButton
                          label={data.form.title.unidentified_logs_auto_send}
                          name='unidentified_logs_auto_send_flg'
                          onButtonLabel={data.button.approve}
                          offButtonLabel={data.button.notApprove}
                          value={state.settings.unidentified_logs_auto_send_flg}
                          onChange={() => toggleUnidentifiedLogsAutoSend()}
                        />
                      </li>
                      {!!state.settings
                        .default_use_check_in_reflect_to_result_flg && (
                        <li className='form-list__item'>
                          <OnOffRadioButton
                            label={
                              data.form.title.use_check_in_reflect_to_result_flg
                            }
                            name='use_check_in_reflect_to_result_flg'
                            onButtonLabel={data.button.on}
                            offButtonLabel={data.button.off}
                            value={
                              state.settings.use_check_in_reflect_to_result_flg
                            }
                            onChange={toggleCheckInReflectToResult}
                            disabled={
                              !state.settings.belongs_to_main_jv_flg ||
                              isManagerRoleId(LocalStorageService.getRoleId())
                            }
                            error={!!state.errorStartDate}
                            messageDisable={
                              !state.settings.belongs_to_main_jv_flg
                                ? messageUtility.getMessage('I-002-016-01')
                                : messageUtility.getMessage('I-002-017-01')
                            }
                          />
                        </li>
                      )}
                      {!!state.settings
                        .default_use_check_in_reflect_to_result_flg &&
                        !!state.settings.use_check_in_reflect_to_result_flg && (
                          <li className='form-list__item'>
                            <div className='reflect_to_result_start_date__label'>
                              <span className='label'>
                                {
                                  data.form.title
                                    .use_check_in_reflect_to_result_start_date
                                }
                                {state.settings.defaultReflectResultFlg ===
                                  RADIO_BUTTON.Off && <RequireIcon />}
                              </span>
                            </div>
                            <div
                              className={`${
                                state.errorStartDate
                                  ? 'form__error'
                                  : 'reflect_to_result_start_date'
                              } form__element`}
                            >
                              <ReactDropDownCalender
                                disabled={
                                  state.settings
                                    .use_check_in_reflect_to_result_flg ===
                                  state.settings.defaultReflectResultFlg
                                }
                                value={
                                  state.settings
                                    .use_check_in_reflect_to_result_start_date
                                }
                                onChange={setReflectToResultStartDate}
                              />
                              {state.errorStartDate && (
                                <div className='form-list__alert show'>
                                  {state.errorStartDate}
                                </div>
                              )}
                              {state.settings.defaultReflectResultFlg ===
                                RADIO_BUTTON.Off && (
                                <div className='form-list__supplemental-info'>
                                  {messageUtility.getMessage('I-002-014-01')}
                                </div>
                              )}
                            </div>
                          </li>
                        )}
                      <li
                        className='form-list__item'
                        style={{ borderBottom: 'none' }}
                      >
                        <div className='integration-service__label'>
                          <span className='label'>
                            {data.form.title.integration_service}
                          </span>
                        </div>
                        <div className='integration-service__element'>
                          {state.integrationServicesEnabled && (
                            <React.Fragment>
                              <ul className='multi-select'>
                                {_.map(
                                  state.integrationServices,
                                  (option, index) => (
                                    <React.Fragment>
                                      <li
                                        className={`multi-select__item ${
                                          shouldBeDisabled(option.id)
                                            ? 'disabled'
                                            : ''
                                        } ${
                                          state.settings.integration_service_ids.includes(option.id)
                                            ? 'selected'
                                            : ''
                                        }`}
                                        key={index}
                                      >
                                        <div className='btn-checkbox'>
                                          <label
                                            htmlFor={`multi-select-integrationService-id-${
                                              option.id
                                            }`}
                                          >
                                            <input
                                              id={`multi-select-integrationService-id-${
                                                option.id
                                              }`}
                                              type='checkbox'
                                              checked={state.settings.integration_service_ids.includes(
                                                option.id
                                              )}
                                              onChange={() =>
                                                toggleIntegrationService(
                                                  option.id
                                                )
                                              }
                                            />
                                            <i className='i-square-checkbox i-3x' />
                                          </label>
                                        </div>
                                        <div
                                          className='multi-select__label'
                                          onClick={() =>
                                            toggleIntegrationService(
                                              option.id
                                            )
                                          }
                                        >
                                          {option.name}
                                        </div>
                                        {option.id == INTEGRATION_SERVICES.bankenFace.id && (
                                          <div className='body-temperature-threshold'>
                                            <div className='body-temperature-threshold__prefix'>
                                              {data.form.body_temperature_threshold.label}
                                            </div>
                                            <div className='body-temperature-threshold__select'>
                                              <SelectBox
                                                name='body_temperature_threshold'
                                                value={
                                                  state.settings.body_temperature_threshold
                                                }
                                                isPlaceholderHidden={true}
                                                items={BODY_TEMPERATURE_THRESHOLD}
                                                onChange={event => {
                                                  setBodyTemperatureThreshold(
                                                    event.target.value
                                                  );
                                                }}
                                              />
                                            </div>
                                            <div className='body-temperature-threshold__suffix'>
                                              {data.form.body_temperature_threshold.celsius}
                                            </div>
                                          </div>
                                        )}
                                        {option.id == INTEGRATION_SERVICES.kaoReko.id &&
                                          isManagerRoleId(
                                            LocalStorageService.getRoleId()
                                          ) && (
                                            <React.Fragment>
                                              <div
                                                style={{
                                                  flexBasis: '100%',
                                                  height: 0,
                                                }}
                                              />
                                              <div
                                                style={{ paddingLeft: 26 }}
                                                className='safari-linebreak'
                                              >
                                                顔レコは選択いただくと請求が発生します。そのため、本機能は本社管理者・支店管理者のみが設定できます。
                                              </div>
                                            </React.Fragment>
                                          )}
                                      </li>
                                      {option.id == INTEGRATION_SERVICES.bankenFace.id && (
                                        <hr />
                                      )}
                                      {option.id == INTEGRATION_SERVICES.kaoReko.id && (
                                           <React.Fragment>
                                          <li className={
                                            `multi-select__item use-worker-entrance-app-flg ${
                                              !state.settings.integration_service_ids.includes(INTEGRATION_SERVICES.kaoReko.id)
                                                ? 'disabled'
                                                : 'selected'
                                            }`}
                                          >
                                            <div className='btn-checkbox'>
                                              <label htmlFor='use-worker-entrance-app-flg'>
                                                <input
                                                  id='use-worker-entrance-app-flg'
                                                  type='checkbox'
                                                  checked={state.settings.use_worker_entrance_app_flg}
                                                  onChange={() =>
                                                    toggleUseWorkerEntranceAppFlg()
                                                  }
                                                />
                                                <i className='i-square-checkbox i-3x'></i>
                                              </label>
                                            </div>
                                            <div 
                                              className='multi-select__label'
                                              onClick={() =>
                                                toggleUseWorkerEntranceAppFlg()
                                              }
                                            >{data.form.use_worker_entrance_app_flg}</div>
                                          </li>
                                          <li>
                                            <button
                                              className={`btn-area btn--stay ${(!state.fieldAreaVisibilityFlg || !state.settings.use_worker_entrance_app_flg) ? 'btn--disabled' : ''}`}
                                              disabled={!state.fieldAreaVisibilityFlg || !state.settings.use_worker_entrance_app_flg}
                                              onClick={() => {
                                                this.props.loadPage(InOutFieldAreas);
                                                _urlParamManager.setPage('InOutFieldAreas', this.props.vw);
                                                setTimeout(() => {
                                                  EventManager.trigger(EventType.LAYOUT_UPDATE, {});
                                                }, 1);
                                              }}
                                            >
                                              {data.button.area}
                                            </button>
                                          </li> 
                                           <hr />
                                          </React.Fragment>
                                      )}
                                    </React.Fragment>
                                  )
                                )}
                              </ul>
                              {state.integrationServicesEnabled && (
                                <div className='integration-service-note'>
                                  <div className='reference-mark'>
                                    {data.referenceMark}
                                  </div>
                                  <div className='safari-linebreak'>
                                    {data.form.integration_service_comment}
                                  </div>
                                </div>
                              )}
                            </React.Fragment>
                          )}
                        </div>
                      </li>
                      <li
                        className='form-list__item'
                        style={{ borderTop: '1px dashed #E0E0E0' }}
                      >
                        <OnOffRadioButton
                          label={data.form.title.spot_check}
                          name='spot_check'
                          onButtonLabel={SPOT_CHECK_STATUS.check.name}
                          offButtonLabel={SPOT_CHECK_STATUS.dontCheck.name}
                          value={state.settings.spot_flg}
                          onChange={() => toggleSpotFlg()}
                        />
                      </li>
                      {isPrimeRoleId(LocalStorageService.getRoleId()) &&
                        !!state.settings.k_mobile_available_flg && (
                          <React.Fragment>
                            <li
                              className='form-list__item'
                              style={{ borderTop: '1px dashed #E0E0E0' }}
                            >
                              <OnOffRadioButton
                                label={data.form.title.use_k_mobile_flg}
                                name='use_k_mobile_flg'
                                onButtonLabel={K_MOBILE_CHECK_STATUS.check.name}
                                offButtonLabel={
                                  K_MOBILE_CHECK_STATUS.dontCheck.name
                                }
                                value={state.settings.use_k_mobile_flg}
                                onChange={() => toggleKMobileFlg()}
                              />
                            </li>
                            <li
                              className='form-list__item'
                              style={{ borderTop: '1px dashed #E0E0E0' }}
                            >
                              <div className='k-mobile-field-id__label'>
                                <span className='label'>
                                  {data.form.title.original_field_id}
                                </span>
                              </div>
                              <div className='k-mobile-field-id__element'>
                                <input
                                  type='number'
                                  min='0'
                                  defaultValue={
                                    state.settings.original_field_id
                                  }
                                  name='original_field_id'
                                  disabled={
                                    !isNullOrUndefinedOrEmptyStr(
                                      state.settings.original_field_id
                                    ) &&
                                    (state.settings.original_field_status !==
                                      0 &&
                                      !isNullOrUndefinedOrEmptyStr(
                                        state.settings.original_field_status
                                      ))
                                  }
                                  onBlur={e =>
                                    updateOriginalFieldId(e.target.value)
                                  }
                                />
                                <div className='k-mobile-note'>
                                  <div className='reference-mark'>
                                    {data.referenceMark}
                                  </div>
                                  <div className='safari-linebreak'>
                                    {data.form.k_mobile_comment}
                                  </div>
                                </div>
                              </div>
                            </li>
                          </React.Fragment>
                        )}
                    </FormList>
                  </div>
                </div>
              </div>

              <Information
                title={state.informationModal.title}
                message={state.informationModal.message}
                buttonText={state.informationModal.buttonText}
                multilineText={state.informationModal.multilineText}
                rootClassName={state.informationModal.rootClassName}
                visible={
                  state.dialogStatus ===
                    DIALOG_STATUS.registerStartDialogEnabled.id ||
                  state.dialogStatus ===
                    DIALOG_STATUS.updateSuccessDialogEnabled.id ||
                  state.dialogStatus ===
                    DIALOG_STATUS.notExistFieldIdDialogEnabled.id ||
                  state.dialogStatus ===
                    DIALOG_STATUS.unidentifiedLogsAutoSendDialogEnabled.id ||
                  state.dialogStatus ===
                    DIALOG_STATUS.otherErrorDialogEnabled.id
                }
                onClose={() => closeDialog()}
              />

              <Information
                visible={state.visibleDownloadErrorDialog}
                title='ダウンロードエラー'
                message={messageUtility.getMessage('E-000-056')}
                buttonText={messageUtility.getMessage('I-000-017')}
                onClose={() => setVisibleDownloadErrorDialog(false)}
                buttonClassName='btn--sub'
              />

              <Confirmation
                visible={
                  state.dialogStatus === DIALOG_STATUS.registerDialogEnabled.id
                }
                title={state.confirmationModal.title}
                message={state.confirmationModal.message}
                confirmButtonText={state.confirmationModal.buttonText}
                cancelButtonText={data.button.back}
                isNegative={true}
                onCancel={() => closeDialog()}
                onConfirm={() => registerFaceImages()}
                rootClassName={styles.confirmDialog}
                negativeButtonClassName={
                  state.confirmationModal.buttonClassName
                }
              />

              <Confirmation
                visible={
                  state.dialogStatus ===
                  DIALOG_STATUS.offReflectResultDialogEnabled.id
                }
                title='注意'
                message={messageUtility.getMessage('W-002-001-007')}
                confirmButtonText={data.button.off}
                cancelButtonText={data.button.back}
                isNegative={true}
                onCancel={() => closeDialog()}
                onConfirm={offCheckInReflectToResult}
                rootClassName={styles.confirmDialog}
              />

              <ConfirmAppStart
                visible={
                  state.dialogStatus ===
                  DIALOG_STATUS.faceAppUseStartDialogEnabled.id
                }
                title={state.confirmAppStartModal.title}
                message={state.confirmAppStartModal.message}
                confirmButtonText={state.confirmAppStartModal.buttonText}
                checkBoxText={state.confirmAppStartModal.checkBoxText}
                confirmCheckbox={state.confirmAppStartModal.confirmCheckbox}
                effectiveButtonClassName={
                  state.confirmAppStartModal.effectiveButtonClassName
                }
                cancelButtonText={data.button.cancel}
                isNegative={false}
                onCancel={() => closeDialog()}
                onConfirm={() => updateFieldSettings()}
                onConfirmCheckbox={() => toggleConfirmCheckbox()}
                downloadPdf={() =>
                  downloadFile(
                    data.fileDownload.fileCode,
                    data.fileDownload.fileName
                  )
                }
                rootClassName={styles.confirmDialog}
                negativeButtonClassName={
                  state.confirmAppStartModal.buttonClassName
                }
              />

              <ConfirmAppEnd
                visible={
                  state.dialogStatus ===
                  DIALOG_STATUS.faceAppUseEndDialogEnabled.id
                }
                title={state.confirmAppEndModal.title}
                message={state.confirmAppEndModal.message}
                confirmButtonText={state.confirmAppEndModal.buttonText}
                isNegative={false}
                onCancel={() => closeDialog()}
                onConfirm={() => updateFieldSettings()}
                rootClassName={styles.confirmDialog}
              />

              <LoadingModal visible={state.isLoading} />
            </React.Fragment>
          )}
        </FieldSettingsContext.Consumer>
      </FieldSettingsStore>
    );
  }
}

// 定数
const data = {
  title: '現場設定',
  button: {
    update: '更新',
    back: '戻る',
    cancel: 'キャンセル',
    on: 'ON',
    off: 'OFF',
    approve: '承認する',
    notApprove: '承認しない',
    area: 'エリア設定',
  },
  form: {
    title: {
      day_crossing_time: '日またぎ時刻',
      recording_method: '記録方法',
      ccus_auto_send: 'CCUS自動送信',
      automatic_approval: '自動承認',
      use_check_in_reflect_to_result_flg: '入退場実績の作業実績反映機能',
      use_check_in_reflect_to_result_start_date:
        '入退場実績の作業実績反映開始日',
      integration_service: '顔認証機器',
      body_temperature_threshold: '',
      spot_check: '社員・ゲストの入退場管理',
      unidentified_logs_auto_send: '不明な入退場データのCCUS送信',
      use_k_mobile_flg: 'K-Mobile端末管理',
      original_field_id: 'K-Mobile引継ぎ元現場ID',
    },
    body_temperature_threshold: {
      label: '体温検出基準値',
      celsius: '°C',
    },
    integration_service_comment:
      '顔認証機器を設定すると、現場に所属する作業員の情報が各認証機器のサーバーに送信されます。\n誤って設定しないよう、ご注意ください。',
    recording_method_comment:
      '作業員の入退場実績を手入力で追加する際の登録方法です。\n「入場のみ」とすると追加時に入場時刻のみが表示されます。',
    recording_method_banken_comment:
      'BANKEN FACEの使い方変更をご希望の場合はお手数ですが\nBANKENカスタマーサポートまでお問い合わせください。',
    k_mobile_comment:
      '引継ぎ元現場IDを設定すると、この現場の着工日に引継ぎ元現場からK-Mobile端末が移管されます。',
    use_worker_entrance_app_flg: '顔レコfor技能者アプリ利用',
  },
  dateColon: '：',
  referenceMark: '※',

  fileDownload: {
    fileCode: 'faceRecognitionPriceList',
    fileName: '顔レコ ご利用料金表.pdf',
  },
};



// WEBPACK FOOTER //
// ./src/pages/FieldSettings.jsx